import React from 'react';
import { CTAButton } from './CTAButton';
import { Check, ShieldCheck } from 'lucide-react';
export function ProductSticky() {
  return <aside className="hidden lg:block sticky top-8 h-fit w-[300px] bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-235">
      <div className="bg-[#7C3AED] text-white text-center py-2 text-sm font-bold uppercase tracking-wider" data-id="element-236">
        Special Offer Available
      </div>

      <div className="p-6" data-id="element-237">
        <div className="aspect-square bg-gray-100 rounded-lg mb-4 overflow-hidden relative" data-id="element-238">
          <img src="https://cdn.magicpatterns.com/uploads/rYqLWSmP9WUqMFn5HYzPPE/openart-image_-nW0JiE6_1769469000084_raw_(1).jpg" alt="DeepClean Flow Product" className="object-cover w-full h-full" data-id="element-239" />
        </div>

        <h3 className="font-serif font-bold text-xl text-gray-900 mb-4" data-id="element-240">
          The DeepClean Flow
        </h3>

        <ul className="space-y-2 mb-6 text-sm text-gray-600" data-id="element-241">
          <li className="flex items-start gap-2" data-id="element-242">
            <Check className="w-4 h-4 text-[#7C3AED] mt-0.5 flex-shrink-0" data-id="element-243" />
            <span data-id="element-244">Gentle on sensitive gums</span>
          </li>
          <li className="flex items-start gap-2" data-id="element-245">
            <Check className="w-4 h-4 text-[#7C3AED] mt-0.5 flex-shrink-0" data-id="element-246" />
            <span data-id="element-247">Portable & cordless design</span>
          </li>
          <li className="flex items-start gap-2" data-id="element-248">
            <Check className="w-4 h-4 text-[#7C3AED] mt-0.5 flex-shrink-0" data-id="element-249" />
            <span data-id="element-250">60-day battery life</span>
          </li>
        </ul>

        <CTAButton href="https://flossfocus.com/products/the-flossfocus-precision" fullWidth className="text-sm py-3 mb-4" data-id="element-251">
          Check Availability
        </CTAButton>

        <div className="flex items-center justify-center gap-2 text-xs text-gray-500" data-id="element-252">
          <ShieldCheck className="w-4 h-4" data-id="element-253" />
          <span data-id="element-254">60-Day Money-Back Guarantee</span>
        </div>
      </div>
    </aside>;
}